(function dpSwatches(){
  var colorMap={
    'negro':'#1a1a1a','negra':'#1a1a1a','blanco':'#f5f5f5','blanca':'#f5f5f5',
    'blanco crema':'#fffdd0','crema':'#fffdd0','marfil':'#fffff0','beige':'#d4b896',
    'rojo':'#c0392b','roja':'#c0392b','rojo vino':'#7b1f3a','vino':'#7b1f3a',
    'burdeo':'#800020','bord\u00f3':'#800020','bordo':'#800020',
    'rosa':'#f48fb1','rosado':'#f48fb1','fucsia':'#e91e8c','coral':'#ff6b6b',
    'naranja':'#e67e22','amarillo':'#f1c40f','mostaza':'#c9a84c','amarillo mostaza':'#c9a84c',
    'verde':'#27ae60','verde menta':'#98fb98','verde esmeralda':'#50c878',
    'verde agua':'#66cdaa','verde oscuro':'#1a5c2b','verde-azulado':'#2e8b84',
    'aqua':'#00ced1','turquesa':'#40e0d0','celeste':'#87ceeb',
    'azul':'#2980b9','azul claro':'#87ceeb','azul marino':'#001f5b',
    'azul oscuro':'#0a2463','azulino':'#5d8aa8','azul rey':'#4169e1',
    'morado':'#8b008b','violeta':'#7f00ff','violeta oscuro':'#4b0082',
    'lila':'#c8a2c8','lavanda':'#e6e6fa','purpura':'#7b68c4','p\u00farpura':'#7b68c4',
    'gris':'#808080','gris claro':'#d3d3d3','gris oscuro':'#404040',
    'plateado':'#c0c0c0','plata':'#c0c0c0','dorado':'#ffd700','oro':'#ffd700',
    'caf\u00e9':'#795548','cafe':'#795548','marr\u00f3n':'#795548','marron':'#795548',
    'chocolate':'#5c3317','terracota':'#e2725b','ocre':'#cc7722',
    'multicolor':'linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff)',
    'estampado':'linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#baffc9)',
    'floral':'linear-gradient(135deg,#ffb3ba,#ffdfba,#baffc9,#bae1ff)'
  };

  function getBg(name){
    var n=(name||'').toLowerCase().trim();
    if(colorMap[n]) return colorMap[n];
    for(var k in colorMap){if(n.includes(k)||k.includes(n)) return colorMap[k];}
    var h=0;for(var i=0;i<n.length;i++) h=n.charCodeAt(i)+((h<<5)-h);
    return '#'+('000000'+((h&0xFFFFFF).toString(16))).slice(-6);
  }

  function injectCard(card){
    if(card.querySelector('.dp-swatches')) return;
    var link=card.querySelector('a[href*="/products/"]');
    if(!link) return;
    var handle=link.href.match(/\/products\/([^?#]+)/)?.[1];
    if(!handle) return;
    fetch('/products/'+handle+'.js')
      .then(function(r){return r.json();})
      .then(function(p){
        var colors=[],seen={};
        (p.options||[]).forEach(function(opt){
          if((opt.name||'').toLowerCase()==='color'){
            opt.values.forEach(function(v){if(!seen[v]){seen[v]=1;colors.push(v);}});
          }
        });
        if(!colors.length) return;
        var wrap=document.createElement('div');
        wrap.className='dp-swatches';
        wrap.style.cssText='display:flex;flex-wrap:wrap;gap:4px;padding:3px 0 1px;align-items:center;min-height:20px;';
        var MAX=7;
        colors.slice(0,MAX).forEach(function(c){
          var dot=document.createElement('span');
          dot.title=c;
          var bg=getBg(c);
          dot.style.cssText='display:inline-block;width:13px;height:13px;border-radius:50%;border:1.5px solid rgba(0,0,0,0.18);flex-shrink:0;background:'+bg+';transition:transform 0.15s,border-color 0.15s;cursor:pointer;';
          dot.addEventListener('mouseover',function(){this.style.transform='scale(1.3)';this.style.borderColor='#7b68c4';});
          dot.addEventListener('mouseout',function(){this.style.transform='';this.style.borderColor='rgba(0,0,0,0.18)';});
          wrap.appendChild(dot);
        });
        if(colors.length>MAX){
          var more=document.createElement('span');
          more.style.cssText='font-size:10px;color:#aaa;margin-left:2px;';
          more.textContent='+'+(colors.length-MAX);
          wrap.appendChild(more);
        }
        var titleEl=card.querySelector('.product-title,[class*="product-title"],h3,h4');
        var priceEl=card.querySelector('.price,[class*="price"]');
        var ref=titleEl||priceEl;
        if(ref&&ref.parentNode) ref.parentNode.insertBefore(wrap,ref.nextSibling);
        else card.appendChild(wrap);
      }).catch(function(){});
  }

  function run(){
    document.querySelectorAll('.product-grid__item,.resource-list__item').forEach(injectCard);
  }

  // Multiple attempts to handle Horizon lazy rendering
  function scheduleRun(){
    run();
    setTimeout(run,800);
    setTimeout(run,2000);
    setTimeout(run,4000);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',scheduleRun);
  } else {
    scheduleRun();
  }

  // MutationObserver for infinite scroll
  function setupObserver(){
    var grid=document.querySelector('.product-grid,results-list,.paginated-list');
    if(grid){
      new MutationObserver(function(muts){
        muts.forEach(function(m){if(m.addedNodes.length) setTimeout(run,500);});
      }).observe(grid,{childList:true,subtree:true});
    } else {
      setTimeout(setupObserver,1000);
    }
  }
  setupObserver();
})();
